import { render } from "./CategoriaSeleccion.vue?vue&type=template&id=255f625a&scoped=true"
import script from "./CategoriaSeleccion.vue?vue&type=script&lang=js"
export * from "./CategoriaSeleccion.vue?vue&type=script&lang=js"

import "./CategoriaSeleccion.vue?vue&type=style&index=0&id=255f625a&scoped=true&lang=stylus"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-255f625a"]])

export default __exports__